import { getJsonFromServer } from '@fsp-lib/app-context';

export async function doPreBootstrap() {
  const serverContext = await getServerContext();

  // Store the context for later use
  localStorage.setItem(
    'fspDiscoveryFlightContext',
    JSON.stringify(serverContext),
  );

  return serverContext;
}

async function getServerContext(): Promise<DiscoveryFlightContext> {
  try {
    const responseJson = (await getJsonFromServer(
      '/Context/DiscoveryFlightContext',
    )) as DiscoveryFlightContext;
    return responseJson;
  } catch (e) {
    console.error('Error fetching Discovery Flight Context:', e);
    return Promise.reject(e);
  }
}

export interface DiscoveryFlightContext {
  apiEnvironment: string;
  discoveryFlightApiUrl: string;
  recaptchaKey: string;
  subscriptionKey: string;
  payrixBaseUrl: string;
  payrixPayFieldsScriptUrl: string;
  payrixApiKey: string;
}
